export const VOICE_DEBRIEF_MAX_BYTES = 10 * 1024 * 1024;
export const VOICE_DEBRIEF_MAX_SECONDS = 10 * 60;
export const VOICE_DEBRIEF_MIN_SECONDS = 2;

export const VOICE_DEBRIEF_MIME_TYPES = [
  "audio/mp4",
  "audio/webm;codecs=opus",
  "audio/webm",
  "audio/ogg;codecs=opus",
  "audio/ogg"
] as const;

export const preferredVoiceMimeType = (supports: (mimeType: string) => boolean) =>
  VOICE_DEBRIEF_MIME_TYPES.find(supports) ?? "";

export const validateVoiceDebrief = (blob: Pick<Blob, "size" | "type">, durationSeconds: number) => {
  if (!Number.isFinite(durationSeconds) || durationSeconds < VOICE_DEBRIEF_MIN_SECONDS || blob.size === 0) {
    return "Nahrávka je príliš krátka.";
  }
  if (durationSeconds > VOICE_DEBRIEF_MAX_SECONDS) return "Nahrávka môže mať najviac 10 minút.";
  if (blob.size > VOICE_DEBRIEF_MAX_BYTES) return "Nahrávka je príliš veľká. Maximum je 10 MB.";
  const baseType = blob.type.split(";")[0].toLocaleLowerCase();
  if (!VOICE_DEBRIEF_MIME_TYPES.some((type) => type.split(";")[0] === baseType)) {
    return "Tento formát nahrávky nie je podporovaný.";
  }
  return undefined;
};
